export enum WatrAction {
    Edit = 1,
    ResendInvitation = 2,
    CompleteForDonor = 3,
    UploadTravelDetails = 4,
    ConfirmDonation = 5,
    RequestAddlDays = 6,
    Audit = 7,
    TravelDetails = 8,
    CancelRequest = 9,
    ApproveWeekReimbursements = 10,
    ReimburseWages = 11,
    ReimburseTravel = 12,
    VerifyWages = 13,
    VerifyTravel = 14,
    SetPaymentError = 15,
    ResolvePaymentError = 16,
    RequestDonorReview = 17,
    ApproveAdvancedReimbursement = 18,
    DenyAdvancedReimbursement = 19,
    HoldAdvancedReimbursement = 20,
    ReleaseAdvancedReimbursement = 21,
    ReconcileTransactions = 22,
    ActivateAdvancedReimbursement = 23,
    Divider = -1
}